module.exports = __webpack_public_path__ + "img/vrtree.301800a4.jpg";